<template>
  <div class="controller-news-category">
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }">
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tên" :colon="false" prop="name">
          <a-input v-model="form.name" placeholder="Tên" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" :colon="false" label="Danh mục release">
          <a-switch v-model="form.type" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Nội dung" :colon="false" prop="content">
          <a-textarea :rows="5" v-model="form.content" placeholder="Nội dung" />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input type="file" accept="image/png, image/svg, image/jpeg, image/gif, image/jpg" @change="onAvatarChange" />
        </a-form-model-item>
        <img v-show="avatarUrl" id="preview-avatar" :src="avatarUrl" class="preview-avatar" />
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button type="primary" :loading="callingAPI" @click="handleSubmit">
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  createCategory,
  updateCategory,
  fetchById
} from "@/services/landing-page/news/category";

export default {
  name: "ControllerNewsCategory",
  data() {
    return {
      callingAPI: false,

      form: {
        name: "",
        content: "",
        status: 1,
        type: false,
        image: null
      },
      rules: {
        name: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"]
          }
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"]
          }
        ]
      },

      avatarUrl: ""
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        const response = await fetchById(this.$route.params.id);
        this.form.name = response.data.name;
        this.form.content = response.data.content;
        this.avatarUrl = `${process.env.VUE_APP_LANDING_PAGE_BACKEND_URL}/${response.data.image
          }`;
        this.form.status = response.data.status;
        this.form.type = response.data.type === 1 ? true : false;
      } catch (error) { }
    },
    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.form.image = file;
        this.avatarUrl = URL.createObjectURL(file);
      }
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (!this.avatarUrl) {
            this.$message.error("Vui lòng upload ảnh đại diện!");
            return;
          }
          try {
            this.callingAPI = true;
            const formData = new FormData();
            formData.append("name", this.form.name);
            formData.append("content", this.form.content);
            formData.append("status", this.form.status);
            formData.append("type", this.form.type ? 1 : 2);
            if (this.form.image) {
              formData.append("image", this.form.image);
            }
            let response = null;
            if (this.$route.params.id) {
              formData.append("_method", "PUT");
              response = await updateCategory(this.$route.params.id, formData);
            } else {
              response = await createCategory(formData);
            }
            this.callingAPI = false;
            this.callingAPI = false;
            if (response.status == 1) {
              const message = this.$route.params.id
                ? "Cập nhật thành công."
                : "Thêm mới thành công.";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
              this.$router.push({path: "/news/category"})
            } else {
              this.$notification.error({
                message: "Thất bại",
                description: response.errors[0],
              });
            }
          } catch (error) {
            console.log(error);
            this.callingAPI = false;
            let message = this.$route.params.id
              ? "Cập nhật thất bại"
              : "Thêm mới thất bại";
            this.$notification.error({
              message: "Thất bại",
              description: message
            });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>